import { CTMTContract, liCTMTContract, giCTMTContract, cpCTMTConAdd, cpCTMTContract, giCTMTConAdd } from "./ConAddsAndABIs"
import { ethers } from "ethers";
import React, { useEffect, useState } from "react";

function Provideractions(){

    const [walletAddress, setWalletAddress] = useState("");    
    const [depositCTMTValue, setDepositCTMTValue] = useState("");     
    const [quitTime, setQuitTime] = useState("");
    const [redeemableGiCTMT, setRedeemableGiCTMT] = useState("");  
    const [rGiCTMTValue, setRGiCTMTValue] = useState("");  
    const [liRedemptionTime, setLIRedemptionTime] = useState("");
    const [giRedemptionTime, setGIRedemptionTime] = useState("");    
    const [wManager, setWManager] = useState("");

    const [quitManagerButton, setQuitManagerButton] = useState("");    

useEffect(() => {  

    const getWalletAddress = async () => {
        const accounts = await window.ethereum.request({
            method: "eth_requestAccounts",
        });
        const account = accounts[0]
        const accountF = account.toString()
        setWalletAddress(accountF);

    }
    
    getWalletAddress()
        .catch(console.error)    
        
  const getWManager = async () => {
      const sellectedTFT = await cpCTMTContract.withManager(walletAddress)
      const sellectedTFTF = sellectedTFT.toString()
        setWManager(sellectedTFTF) 
      }

      getWManager()
      .catch(console.error)  
 
      

      const getQuitTime= async () => {
        const provided = await cpCTMTContract.provsCTMTDeps(walletAddress) / (10**18)
        const cpCTMT = await cpCTMTContract.cpCTMTIssued(walletAddress) / (10**18)
        const qStat = await cpCTMTContract.quitted(walletAddress)
        const qTime = await cpCTMTContract.quitTime(walletAddress)
        const qTimeF1 = new Date(qTime * 1000)
        const timeNow = new Date()
        const qTimeF2 = qTimeF1.toString()

            if (qStat === true) {
              setQuitTime('Quitted Already')
            } else if (qStat === false) {
                if (provided === 0) {
                  setQuitTime('N.A.')
              } else {
                  setQuitTime(qTimeF2)
              }
            }

            if (qStat === false && timeNow > qTimeF1) {
              setQuitManagerButton(<button onClick={handleQuitManager}>Quit Sapphire Salt Mining</button>)
            }
          }
    
          getQuitTime()
            .catch(console.error)       

            const getRedeemableGiCTMT = async () => {
                const balance = await giCTMTContract.redeemableGiCTMT(walletAddress) / (10**18)
                const giTS = await giCTMTContract.totalSupply()
                const ctmtInGi = await CTMTContract.balanceOf(giCTMTConAdd)
                const ctmtValueOfGi = ctmtInGi * balance / giTS            
                const commaSeparated = balance.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                const ctmtValueOfGiF = ctmtValueOfGi.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) 
                  setRedeemableGiCTMT(commaSeparated)
                  setRGiCTMTValue(ctmtValueOfGiF)
    
                }
        
            getRedeemableGiCTMT()
                .catch(console.error)  
  
              const getGIRedemptionTime= async () => {
                const quit = await cpCTMTContract.quitted(walletAddress)
                const balance = await giCTMTContract.redeemableGiCTMT(walletAddress) / (10**18)
                if (quit === false || balance === 0) {
                  setGIRedemptionTime("N.A.")
                } else
                {const fdTime = await giCTMTContract.redemptionStart(walletAddress)
                const fdTimeF1 = new Date(fdTime * 1000)
                const fdTimeF2 = fdTimeF1.toString()
                  setGIRedemptionTime(fdTimeF2)}

                  }
            
                  getGIRedemptionTime()
              .catch(console.error) 

              const getLIRedemptionTime= async () => {
                const quit = await cpCTMTContract.quitted(walletAddress)
                const balance = await liCTMTContract.redeemableLiCTMT(walletAddress) / (10**18)
              if (quit === false || balance === 0) {
                  setLIRedemptionTime("N.A.")
              } else
              {const fdTime = await liCTMTContract.redemptionStart(walletAddress)
              const fdTimeF1 = new Date(fdTime * 1000)
              const fdTimeF2 = fdTimeF1.toString()
                  setLIRedemptionTime(fdTimeF2)}
  
                  }
          
                  getLIRedemptionTime()
                  .catch(console.error) 


})

const handleQuitManager = async (e) => {
    e.preventDefault();
    const txn = await cpCTMTContract.quitManager()
    await txn.wait();
} 

const handleCTMTApproval = async (e) => {
    e.preventDefault();
    const busdAllow = '1000000000000'
    console.log(busdAllow)
    const uintValue = ethers.utils.parseUnits(busdAllow, 18)
    const txn = await CTMTContract.approve(cpCTMTConAdd, uintValue)
    await txn.wait();
    }  

    const handleProvideCTMTChange = (e) => {
      setDepositCTMTValue(e.target.value);
    }    
    
    const handleProvideCTMTSubmit = async (e) => {
        e.preventDefault();
        console.log(depositCTMTValue)
        const uintValue = ethers.utils.parseUnits(depositCTMTValue, 18)
        const txn = await cpCTMTContract.provideCTMT(uintValue)
        await txn.wait();
            setDepositCTMTValue(0);
      }

if (wManager === 'true') 
  {return(
    <div>           
                            <form style={{"textAlign": "center"}} onSubmit={handleCTMTApproval}>
                                <button type={"submit"} className="btn btn-success">Approve CWJC</button>
                            </form><br />
                            <form style={{"textAlign": "center"}} onSubmit={handleProvideCTMTSubmit}>
                                <input style={{"width": "200px"}} type="number" className="form-control" placeholder="0" onChange={handleProvideCTMTChange} value={depositCTMTValue} /> <button style={{"width": "150px"}} type={"submit"} className="btn btn-success">Buy MFWP</button>
                            </form><br/>                        
                          <p style={{"textAlign": "center"}}>{quitManagerButton}</p>
                          <p style={{"fontSize": "12px"}}><b>Quit Manager Available On: </b> {quitTime}</p> 
                          <p style={{"fontSize": "12px"}}><b>Local Insurance Redemption Available On: </b> {liRedemptionTime}</p> 
                          <p style={{"fontSize": "12px"}}><b>Global Insurance Redemption Available On: </b> {giRedemptionTime}</p>
    </div>
  )}

  else {
      return ( 
        <div>

        </div>

    )
  }

 

}


export default Provideractions;